import React from 'react';
import { 
  createBrowserRouter, 
  RouterProvider, 
  createRoutesFromElements,
  Route,
  Navigate,
  Outlet
} from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import ShotTracker from './pages/ShotTracker';
import Leaderboard from './pages/Leaderboard';
import Login from './components/Login';
import Analytics from './pages/Analytics';
import Credits from './pages/Credits';

const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  return currentUser ? <>{children}</> : <Navigate to="/login" />;
};

// Layout component to wrap all routes
const Layout = () => {
  return (
    <div className="min-h-screen bg-background-primary">
      <Navbar />
      <main className="container mx-auto px-4 py-8">
        <Outlet />
      </main>
    </div>
  );
};

const App: React.FC = () => {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route element={<Layout />}>
        <Route path="/login" element={<Login />} />
        <Route path="/tracker" element={
          <PrivateRoute>
            <ShotTracker />
          </PrivateRoute>
        } />
        <Route path="/" element={<Leaderboard />} />
        <Route path="/analytics" element={
          <PrivateRoute>
            <Analytics />
          </PrivateRoute>
        } />
        <Route path="/credits" element={<Credits />} />
      </Route>
    )
  );

  return (
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  );
};

export default App; 